;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('pagingControl', pagingControl)

  function pagingControl () {
    return {
      restrict: 'E',
      scope: {
        visibleTokensCount: '@',
        visibleTokens: '@',
        tokens: '@',
        top: '@',
        count: '@',
        indexToken: '@',
        selected: '&onTokenSelected',
        skipPagesRight: '&onSkipPagesRight',
        skipPagesLeft: '&onSkipPagesLeft'
      },
      templateUrl: '/core/directives/paging-control/paging-control-directive.html?$$REVISION$$',
      link: link
    }
  }

  function link ($scope, element, attributes) {
    // Private
    $scope._SELECTED_CLASS = 'pagingControlSelected'
    $scope.showLeftCrumbs = false
    $scope.showRightCrumbs = false
    $scope._iOldCount = 0
    $scope.visibleTokensCount = $scope.visibleTokensCount > 0 ? $scope.visibleTokensCount : 5
    $scope._currentSelectedToken = null
    $scope.initPoint = 0
    $scope.endPoint = 0

    $scope.startLocked = () => {
      if (!$scope.tokens) {
        return true
      }
      const token = $scope.tokens[0]
      if (token.selected) {
        return true
      }
      return false
    }

    $scope.showButtonSkip = () => {
      if (!$scope.tokens) {
        return true
      }
      const size = $scope.tokens.length
      if (size <= $scope.visibleTokensCount) {
        return false
      }
      return true
    }

    $scope.skipEndLocked = () => {
      if (!$scope.tokens) {
        return true
      }
      const maxSize = $scope.tokens.length
      const endPoint = $scope.endPoint
      if (endPoint >= maxSize) {
        return true
      }
      return false
    }

    $scope.endLocked = () => {
      if (!$scope.tokens) {
        return false
      }
      const maxSize = $scope.tokens.length
      const token = $scope.tokens[maxSize - 1]

      if ($scope.indexToken) {
        const indexToken = parseInt($scope.indexToken, 10)

        $scope.tokens.map(token => {
          token.index === indexToken ? token.selected = true : token.selected = false
        })
      }

      if (token.selected) {
        return true
      }

      return false
    }

    $scope.select = function ($event, token) {
      token.selected = true

      const index = token.index
      $scope.tokens[$scope._currentSelectedToken.index].selected = false
      $scope._currentSelectedToken = token
      let clearToken
      while ((clearToken = $scope.tokenCurrent())) {
        $scope.tokens[clearToken].selected = false
      }

      const indexToken = $scope.tokens.find(token => {
        return token.index === index
      }).index

      $scope.tokens[indexToken].selected = true
      $scope.updateToken(token)
    }

    $scope.nextPage = () => {
      const index = $scope.tokenCurrent()

      if ($scope.endPoint >= $scope.tokens.length) {
        $scope.changeSelected(index, index + 1, true)
        return
      }

      $scope.initPoint++
      $scope.endPoint++

      $scope.changeSelected(index, index + 1)
    }

    $scope.prevPage = () => {
      const index = $scope.tokenCurrent()

      if ($scope.initPoint === 0) {
        $scope.changeSelected(index, index - 1, true)
        return
      }
      $scope.initPoint--
      $scope.endPoint--

      $scope.changeSelected(index, index - 1)
    }

    $scope.leftCrumbsClick = function () {
      $scope.initPoint = 0
      $scope.endPoint = $scope.visibleTokensCount
      const index = $scope.tokenCurrent()

      $scope.changeSelected(index, 0)
    }

    $scope.rightCrumbsClick = function () {
      $scope.initPoint = $scope.tokens.length - $scope.visibleTokensCount
      $scope.endPoint = $scope.tokens.length
      const index = $scope.tokenCurrent()

      $scope.changeSelected(index, $scope.endPoint - 1)
    }

    $scope.changeSelected = (index, newIndex, skipSlice) => {
      $scope.tokens[index].selected = false
      $scope.tokens[newIndex].selected = true
      $scope._currentSelectedToken = $scope.tokens[$scope.initPoint]

      if (!skipSlice) {
        $scope.visibleTokens = $scope.tokens.slice($scope.initPoint, $scope.endPoint)
      }

      $scope.updateToken($scope.tokens[newIndex])
    }

    $scope.tokenCurrent = () => {
      const token = $scope.tokens.find(token => {
        return token.selected === true
      })

      if (token) {
        return token.index
      }
      return false
    }

    $scope.updateToken = token => {
      $scope.selected({
        token: token.index,
        tokenObject: token
      })
    }

    function calculatePagingSkipTokens (count, top) {
      const skipTokensCount = Math.ceil(count / top)
      const pagingSkipTokens = []
      for (let i = 0; i < skipTokensCount; i++) {
        pagingSkipTokens.push({
          index: i,
          pageNumber: i + 1,
          selected: false
        })
      }
      return pagingSkipTokens
    }

    $scope.initialize = function (count) {
      count = parseInt(count, 10)
      if (isNaN(count) || !$scope.top || count === 0) {
        $scope.visibleTokens = []
        return
      }
      $scope.tokens = calculatePagingSkipTokens(count, $scope.top)
      // Set first token selected
      $scope._currentSelectedToken = $scope.tokens[0]
      $scope._currentSelectedToken.selected = true

      $scope.visibleTokens = []
      const visibleTokensConfig = parseInt($scope.visibleTokensCount, 10)
      const visibleTokens = $scope.tokens.length < visibleTokensConfig ? $scope.tokens.length : visibleTokensConfig
      for (let i = 0; i < visibleTokens; i++) {
        $scope.visibleTokens.push($scope.tokens[i])
      }

      // Adjust breadcrum visibility
      if ($scope.tokens.length > parseInt($scope.visibleTokensCount, 10) &&
        $scope.visibleTokens[$scope.visibleTokens.length - 1] !== $scope.tokens[$scope.tokens - 1]) {
        $scope.showRightCrumbs = true
      } else {
        $scope.showRightCrumbs = false
      }
      if ($scope.visibleTokens[0] !== $scope.tokens[0]) {
        $scope.showLeftCrumbs = true
      } else {
        $scope.showLeftCrumbs = false
      }

      $scope.endPoint = $scope.visibleTokensCount

      $scope.tokens[0].selected = true
    }

    // Register event listeners
    $scope.$watch('count', $scope.initialize)
  }
})()
